import { FC } from 'react';

import { styled } from '@mui/material/styles';

const WhiteCircle = styled('circle')(({ theme }) => ({ fill: theme.palette.common.white }));

/**
 * Inner circle of the current (_active_) Step in a `<Stepper variant="symbols" />`.
 */
const CurrentCircle: FC = () => {
  return <WhiteCircle cx={12} cy={12} r={3} />;
};

export default CurrentCircle;
